export const mapCurrencyToSign = {
    GBP: '£',
    EUR: '€',
    USD: '$'
};